module.exports = __webpack_public_path__ + "img/box@2x.69d3f6aa.png";